export enum ServiceTypeKeys {
  prepaid = 'Prepaid',
  postpaid = 'Postpaid',
  fixed = 'Fixed',
  combine = 'Combine',
}
